import component from './comparePeriods.vue'

export default component
